import { useGLTF } from "@react-three/drei";
import React from "react";
import { useMemo } from "react";
import { MathUtils } from "three";
import handleMaterial from "../../shared/components/three/handleMaterials";

const ModelInstance = ({ instance, setCamPos, url }) => {

  const { scene } = useGLTF(url);

  const clone = useMemo(() => {

    if(scene){

      const clone = scene.clone();

      clone.traverse((child) => {
        if (child.type === "Mesh" || child.type === "SkinnedMesh") {
          const newMaterial = handleMaterial(child);
          child.material = newMaterial;
        }
      });

      return clone;

    }

    return <mesh>
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color="red" />
    </mesh>



  }, [scene])


  if (!instance) {
    return null;
  }


  if (instance.isFloor) {
    return (
      <primitive
        name={instance.name}

        onDoubleClick={(e) => {
          e.stopPropagation();
          setCamPos([e.point.x, e.point.y, e.point.z]);

        }}
        object={clone}
        position={instance.position}
        rotation={[
          MathUtils.degToRad(instance.rotation[0]),
          MathUtils.degToRad(instance.rotation[1]),
          MathUtils.degToRad(instance.rotation[2]),
        ]}
        scale={instance.scale}
      ></primitive>
    );
  }


  return (
    <primitive
      name={instance.name}
      object={clone}
      position={instance.position}
      onDoubleClick={(e) => {
        e.stopPropagation();
        console.log("double click", clone);
      }}
      rotation={[
        MathUtils.degToRad(instance.rotation[0]),
        MathUtils.degToRad(instance.rotation[1]),
        MathUtils.degToRad(instance.rotation[2]),
      ]}
      scale={instance.scale}
    ></primitive>
  );
};

export default ModelInstance;
